import styles from "./AddAccounts.module.scss"
import down from "../../../../assets/images/downArrow.svg"
import delete_red from "../../../../assets/images/delete_red.svg"
import error_mark from "../../../../assets/images/error_mark.svg"

import InputTag from "../../../../components/Input/InputTag"
import RadioGroup from "../../../../components/RadioGroup/RadioGroup"
import { contactTag, isValidEmail, isValidPhoneNumber } from "../../../../utils/utils"
import validationError from "../../../../enums/validationError"
import PhoneInput from "../../../../components/PhoneNumber"
import MuiAutoComplete from "../../../../components/MuiAutocomplete"
import { Box } from "@mui/material"

type Props = {
    addStates: any
    addfunctions: any
}
const ContactDetails = (props: Props) => {
    const { addStates, addfunctions } = props
    const { showContactDetails, contactDetails } = addStates
    const {
        removeContactFields,
        addContactFields,
        handleContactChanges,
        toggleContactDetails,
        handleContactTogglePrimary,
    } = addfunctions
    const allPrimaryFalse = contactDetails
        ?.filter((item: any) => item.is_active === 1)
        ?.every((item: any) => item.is_primary === 0)

    return (
        <div>
            {contactDetails
                .filter((item: any) => item.is_active === 1)
                .map((element: any, index: number) => {
                    const isDirty = element.name !== "" || element.phone !== "" || element.email !== "" || element.contact_type?.id !== ""
                    return (
                        <div
                            className={`${styles.editProfile_modal__form__flex} ${styles.address_container}`}
                            style={{
                                borderBottom:
                                    index !== contactDetails.filter((item: any) => item.is_active === 1).length - 1
                                        ? "1px solid #EAEAEA"
                                        : "",
                            }}>
                            <div className={styles.section3} style={{ padding: "6px" }}>
                                <Box className={styles.title} sx={{
                                cursor: "pointer",
                            }} onClick={() => toggleContactDetails(index)}>
                                    <div className={styles.title}>
                                        {element?.name && element?.contact_type
                                            ? `${element?.name} , ${element?.contact_type?.title}`
                                            : `CONTACT ${index + 1}`}
                                        {contactDetails.filter((item: any) => item.is_active === 1)?.length > 1 ? (
                                            <div
                                                className={styles.account_remove}
                                                style={{ marginLeft: 10, cursor: "pointer" }}>
                                                <img
                                                    src={delete_red}
                                                    alt="delete_red"
                                                    onClick={() => removeContactFields(index)}
                                                />
                                            </div>
                                        ) : (
                                            <></>
                                        )}
                                    </div>
                                    <span>
                                        <img
                                            src={down}
                                            alt="down"
                                            style={{
                                                transform: showContactDetails[index] ? "" : "rotate(180deg)",
                                            }}
                                        />
                                    </span>
                                </Box>
                                {showContactDetails[index] && (
                                    <>
                                        {contactDetails.filter((item: any) => item.is_active === 1)?.length > 1 ? (
                                            <div className="flex">
                                                <input
                                                    type="checkbox"
                                                    checked={element?.is_primary === 1}
                                                    onChange={() => handleContactTogglePrimary(index)}
                                                    style={{ cursor: "pointer" }}
                                                />
                                                <span
                                                    className={styles.editProfile_modal__form__flex__label}
                                                    style={{ margin: "0px 10px" }}>
                                                    Set as Primary
                                                </span>
                                                {allPrimaryFalse &&
                                                    element?.is_primary !== 1 &&
                                                    addStates?.toggleError && (
                                                        <img
                                                            src={error_mark}
                                                            alt="error"
                                                            title="One checkbox must be checked to set a single billing address as Primary"
                                                        />
                                                    )}
                                            </div>
                                        ) : (
                                            <div></div>
                                        )}
                                        <div
                                            className={styles.editProfile_modal__form__flex}
                                            style={{
                                                display: "grid",
                                                gridTemplateColumns: "32% 32% 32%",
                                                marginTop: 5,
                                            }}>
                                            <div>
                                                <label className={styles.editProfile_modal__form__flex__label}>
                                                    Name{isDirty ? "*" : ""}
                                                </label>
                                                <InputTag
                                                    required
                                                    name="name"
                                                    placeholder="Enter Name"
                                                    error={!element.name}
                                                    showError={addStates.toggleError && isDirty}
                                                    value={element.name || ""}
                                                    onChange={(e: any) => handleContactChanges(index, e)}
                                                />
                                            </div>
                                            <div>
                                                <label className={styles.editProfile_modal__form__flex__label}>
                                                    Phone Number{isDirty ? "*" : ""}
                                                </label>
                                                <PhoneInput
                                                    value={element.phone || ""}
                                                    countryCode={element.country_code || "+91"}
                                                    placeholder="Number"
                                                    onChange={(e: any) => handleContactChanges(index, e, "phone_full")}
                                                    name="phone"
                                                    error={!isValidPhoneNumber(element?.phone) && addStates.toggleError && isDirty}
                                                    errorText={addStates.toggleError && validationError?.PHONE}
                                                />
                                            </div>

                                            <div>
                                                <label className={styles.editProfile_modal__form__flex__label}>
                                                    E-mail{isDirty ? "*" : ""}
                                                </label>
                                                <InputTag
                                                    required
                                                    name="email"
                                                    placeholder="Enter E-mail"
                                                    value={element.email || ""}
                                                    showError={addStates.toggleError && isDirty}
                                                    error={!isValidEmail(element?.email)}
                                                    errorText={validationError?.EMAIL}
                                                    onChange={(e: any) => handleContactChanges(index, e)}
                                                />
                                            </div>
                                        </div>

                                        <div style={{ margin: "10px 0px", width: "31%" }}>
                                            <label
                                                className={styles.editProfile_modal__form__flex__label}
                                                style={{ paddingBottom: 10 }}>
                                                Contact Tag{isDirty ? "*" : ""}
                                                {!element.contact_type && addStates?.toggleError && isDirty && (
                                                    <img src={error_mark} alt="error" />
                                                )}
                                            </label>
                                            <MuiAutoComplete
                                                options={contactTag}
                                                value={element?.contact_type}
                                                onChange={(e: any) => handleContactChanges(index, e, "contact_type")}
                                                containerHeight="34px"
                                                placeholder="Select Tag"
                                                error={!element?.contact_type?.id && addStates.toggleError && isDirty}
                                            />
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    )
                })}
        </div>
    )
}

export default ContactDetails
